<template>
    <v-dialog v-model="show" width="500">
        <v-card>
            <v-toolbar dark dense color="primary">
                <v-toolbar-title>
                    {{title}}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-col cols="12" class="text-center">
                    {{ message }}
                </v-col>
            </v-card-text>
            <v-row no-gutters class="pb-1">
                <v-col cols="6" class="px-2">
                    <v-btn small rounded block color="error" @click="emitEvent(`confirm`)">
                        Confirm
                    </v-btn>
                </v-col>
                <v-col cols="6" class="px-2">
                    <v-btn small rounded block color="primary" @click="emitEvent(`decline`)">
                        Decline
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                controller: null,
                show: false,
                title: null,
                message: null,
                callback: null,
                callbackData: null,
            };
        },
        methods: {
            showDialog(data) {
                let self = this;
                self.controller = this.get_controller(data.controller)
                self.title = data.title;
                self.message = data.message;
                self.callback = data.callback 
                self.callbackData = data.callbackData;

                self.show = true;
            },
            emitEvent(eventName) {
                let self = this;

                if (eventName == "confirm") {
                    console.log(self.callback);
                    self.controller[self.callback](self.callbackData);
                }

                self.$emit(eventName, eventName);
                self.close();
            },
            close() {
                let self = this;

                self.show = false;
                self.title = null;
                self.message = null;
            },
        },
    };
</script>

<style>
</style>